import { ProductType } from '@willow/graphql-iso/src/app';

export const formatProductType = (productType: ProductType | undefined): string => {
  switch (productType) {
    case 'heloc':
      return 'HELOC';
    case 'conv':
      return 'Conventional';
    case 'fha':
      return 'FHA';
    case 'pih':
      return 'PIH';
    case 'usda':
      return 'USDA';
    case 'va':
      return 'VA';
    case 'bridge':
      return 'Bridge';
    case 'businessPurpose':
      return 'Business Purpose';
    case 'jumbo':
      return 'Jumbo';
    default:
      return '';
  }
};
